import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { AddCircleOutline as AddCircleOutlineIcon } from '@material-ui/icons';
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons';
import { translation } from '../../i18n';
import { ExpansionPanel } from '@material-ui/core';
import { ExpansionPanelSummary } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import { QuestionDto, QuestionType } from '../../pages/questionTypes';
import { observer } from 'mobx-react';
import { IObservableValue } from 'mobx';
import { IconButton } from '@material-ui/core';
import TextQuestionPreview from './questionTypes/TextQuestionPreview';
import MultipleColumnQuestionPreview from './questionTypes/MultipleColumnQuestionPreview';
import MultipleChoiceQuestionPreview from './questionTypes/MultipleChoiceQuestionPreview';

interface Props {
  question: QuestionDto;
  expanded: IObservableValue<string>;
  handleAdd?: (module: QuestionDto) => void;
}

type LocalStyles = 'root' | 'button' | 'heading' | 'secondaryHeading' | 'summaryArea' | 'detailArea' | 'chip';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
  },
  button: {
    margin: theme.spacing.unit,
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    position: 'fixed'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    paddingLeft: theme.spacing.unit
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    paddingLeft: theme.spacing.unit
  },
  summaryArea: {
    alignItems: 'center', display: 'flex',
    flexDirection: 'row',
  },
  detailArea: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'left'
  },
  chip: {
    margin: theme.spacing.unit,
  },

});

type PropsWithStyle = WithStyles<LocalStyles> & Props;

@observer
class QuestionPreview extends React.Component<PropsWithStyle, {}> {

  constructor(props: PropsWithStyle) {
    super(props);
  }

  public render() {
    const {question} = this.props;
    return (
      <ExpansionPanel key={question.id + 'text-question-panel'}
                      expanded={this.props.expanded.get() === (question.id + 'text-question-panel')}
                      onChange={() => {
                        if (this.props.expanded.get() === (question.id + 'text-question-panel')) {
                          this.props.expanded.set('')
                        } else {
                          this.props.expanded.set(question.id + 'text-question-panel')
                        }
                      }
                      }>
        <ExpansionPanelSummary key={question.id + 'text-question-summary'} expandIcon={<ExpandMoreIcon/>}>
          <div className={this.props.classes.summaryArea}>
            {
              this.props.handleAdd &&
              <div>
                <IconButton onClick={(event) => {
                  event.stopPropagation();
                  this.props.expanded.set('');
                  this.props.handleAdd!!(this.props.question);
                }}>
                  <AddCircleOutlineIcon color={'primary'}/>
                </IconButton>
              </div>
            }

            <div>
              {
                question.question ?
                  <Typography className={this.props.classes.heading}>{question.question}</Typography> :
                  <Typography
                    className={this.props.classes.heading}>{translation.t('createCatalogueComponent.noQuestion')}</Typography>
              }
            </div>
            <div><Typography
              className={this.props.classes.secondaryHeading}>{translation.t('question.questionTypes.' + question.questionType)}</Typography>
            </div>
          </div>
        </ExpansionPanelSummary>
        {
          this.renderDetails()
        }
      </ExpansionPanel>
    );
  }

  private renderDetails() {
    switch (this.props.question.questionType) {
      case QuestionType.MULTIPLE_CHOICE: {
        return (
          <MultipleChoiceQuestionPreview classes={this.props.classes} question={this.props.question}/>
        )
      }
      case QuestionType.MULTIPLE_COLUMNS: {
        return (
          <MultipleColumnQuestionPreview classes={this.props.classes} question={this.props.question}/>
        )
      }
      case QuestionType.TEXT: {
        return (
          <TextQuestionPreview classes={this.props.classes} question={this.props.question}/>
        )
      }
    }
  }
}

export default withStyles(localStyles)(QuestionPreview);
